import { SIMPLIFY_NAV_NEW_USER } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

import { isWithinD0Window } from './isWithinD0Window.ts';
import { preloadSpaceBlogCount } from './preloadSpaceBlogCount.ts';

export type OnboardingStateResult = {
	data: { onboardingState?: Array<{ key: string; value?: string | null }> | null } | null;
	hasErrors: boolean;
};

/**
 * Runs simplify-nav preload for space nav when the user is eligible (e.g. D0).
 * Currently preloads space blog count; call with the result of preloadSideNavigationOnboardingState().
 */
export async function preloadSimplifiedNavForSpaceNav(
	spaceKey: string,
	result: OnboardingStateResult,
): Promise<void> {
	const { data, hasErrors } = result;

	if (hasErrors || !data?.onboardingState) {
		return;
	}

	const eligibleEntry = data.onboardingState.find(
		(s) => s.key === SIMPLIFY_NAV_NEW_USER.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
	);
	const startAtEntry = data.onboardingState.find(
		(s) => s.key === SIMPLIFY_NAV_NEW_USER.NTH_USER_D0_SIMPLIFIED_NAV_START_AT,
	);

	if (eligibleEntry?.value !== 'true') {
		return;
	}

	// Relevant for real experiment variant users
	if (startAtEntry?.value) {
		if (isWithinD0Window(startAtEntry.value)) {
			await preloadSpaceBlogCount(spaceKey);
		}
	}
}
